import apiClient from '@/api/apiClient'

export const getAgents = accountId =>
  apiClient.get(`api/v1/accounts/${accountId}/agents`)

export const createAgent = (accountId, payload) =>
  apiClient.post(`api/v1/accounts/${accountId}/agents`, payload)

export const updateAgent = (accountId, id, payload) =>
  apiClient.patch(`api/v1/accounts/${accountId}/agents/${id}`, payload)

export const deleteAgent = (accountId, id) =>
  apiClient.delete(`api/v1/accounts/${accountId}/agents/${id}`)

export const sendAgentPasswordLink = (accountId, id) =>
  apiClient.post(`api/v1/accounts/${accountId}/agents/${id}/password_link`)

export const setAgentAvailability = (accountId, id, availability) =>
  apiClient.post(`api/v1/accounts/${accountId}/agents/${id}/availability`, {
    availability,
  })

export const getAgentAvailabilityChanges = (accountId, id, days) =>
  apiClient.get(
    `api/v1/accounts/${accountId}/agents/${id}/availability_changes`,
    { params: { days } }
  )
